<ng-container *ngIf="placeInfo">
  <div *ngIf="placeInfo.localidad">{{ placeInfo.localidad | titlecase }}</div>
  <div class="text-muted small" *ngIf="placeInfo.provincia; else none">{{ placeInfo.provincia | titlecase }}</div>
</ng-container>

<ng-template #none>
  <span class="text-muted no-select">&#8212;</span>
</ng-template>